import { render, staticRenderFns } from "./ConfiguracoesFreteList.vue?vue&type=template&id=1348cd44"
import script from "./ConfiguracoesFreteList.vue?vue&type=script&lang=js"
export * from "./ConfiguracoesFreteList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports